module.exports = __webpack_public_path__ + "img/dashboard-gif.075b4e60.gif";